import {
    FETCH_GOLF_COURSE_LAYOUTS,
    FETCH_GOLF_COURSE_LAYOUTS_SUCCESS,
    FETCH_GOLF_COURSE_LAYOUTS_FAIL
} from 'actions/golfCourseActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfCourseLayouts: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS,
    layoutNetworkStatus: {}
};

const fetchGolfCourseLayoutsSuccess = (state, action) => {
    return {
        golfCourseLayouts: {
            ...state.golfCourseLayouts,
            [action.courseGlobalId]: action.layouts
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS,
        layoutNetworkStatus: {
            ...state.layoutNetworkStatus,
            [action.courseGlobalId]: NETWORKING_STATUSES.SUCCESS
        }
    };
};

const fetchGolfCourseLayoutsStart = (state, action) => {
    return {
        golfCourseLayouts: {
            ...state.golfCourseLayouts
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING,
        layoutNetworkStatus: {
            ...state.layoutNetworkStatus,
            [action.courseGlobalId]: NETWORKING_STATUSES.FETCHING
        }
    };
};

const fetchGolfCourseLayoutsFail = (state, action) => {
    return state;
};

const handlers = {
    [FETCH_GOLF_COURSE_LAYOUTS_SUCCESS]: fetchGolfCourseLayoutsSuccess,
    [FETCH_GOLF_COURSE_LAYOUTS]: fetchGolfCourseLayoutsStart,
    [FETCH_GOLF_COURSE_LAYOUTS_FAIL]: fetchGolfCourseLayoutsFail
};

export default function golfCourseLayouts(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchGolfCourseLayouts(courseGlobalId, evictCache) {
    return {
        type: FETCH_GOLF_COURSE_LAYOUTS,
        courseGlobalId: courseGlobalId,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

// Getters

export const getGolfCourseLayouts = (state, courseGlobalId) => {
    return state.golfCourseLayout.golfCourseLayouts[courseGlobalId] || [];
};

export const getGolfCourseLayoutsNetworkStatus = (state) => {
    return state.golfCourseLayout.networkingStatus;
};

export const getGolfCourseLayoutNetworkStatus = (state, courseGlobalId) => {
    return state.golfCourseLayout.layoutNetworkStatus[courseGlobalId] || NETWORKING_STATUSES.SUCCESS;
};
